export const handleStatusColors = (status) => {
  switch (status) {
    case "stagingWarning":
      return {
        color: "rgb(255, 111, 30)",
        backgroundColor: "rgb(244 231 227)",
        subColor: "rgb(255, 111, 30, 0.5)"
      };
    case "booking":
      return { color: "#fff", backgroundColor: "#e9e8ff" };
    case "ACTIVE":
      return { color: "#03a9f3", backgroundColor: "rgb(103, 228, 176, 0.1)" };
    case "FINISHED":
      return "#f56342";
    case "SCHEDULED":
      return {
        color: "rgb(255, 174, 174, 1)",
        backgroundColor: "rgb(255, 174, 174, 0.1)"
      };
    case "IN_PROGRESS":
      return {
        color: "rgb(255, 111, 30, 0.8)",
        backgroundColor: "rgb(255, 111, 30, 0.1)"
      };
    case "WAITING_FOR_APPROVAL":
      return {
        color: "#8066FF",
        backgroundColor: "#e9e8ff"
      };
    case "CANCELLED":
      return {
        color: "#ca2efe",
        backgroundColor: "#eebaff"
      };
    case "REJECTED":
      return {
        color: "#ca2efe",
        backgroundColor: "#eebaff"
      };
    case "PAUSED":
      return {
        color: "#0b4bff",
        backgroundColor: "#dceaff"
      };
    default:
      return "#fff";
  }
};
